import 'core-js/stable';
import 'regenerator-runtime/runtime';

require('@engine/setup_ajax');

import * as AnalysisStats from '@engine/features/analysis_stats';
import * as AssignedEntity from '@engine/features/assigned_entities_for';
import * as Blacklists from '@engine/features/blacklists';
import * as Bootstrap from '@engine/features/apply_bootstrap';
import * as Chosen from '@engine/features/apply_chosen';
import * as DashboardPanels from '@engine/features/dashboard';
import * as DashboardRatios from '@engine/features/toggle_ratios';
import * as DatePicker from '@engine/features/datepicker_search';
import * as DateRange from '@engine/features/datepicker_range';
import * as Filters from '@engine/features/dynamic_filters_search';
import * as Locale from '@engine/features/default_locale';
import * as ManagedRecurringItem from '@engine/features/managed_recurring_item';
import * as Menu from '@engine/features/menu';
import * as Modals from '@engine/features/confirmation_modal';
import * as Pagination from '@engine/features/ajax_pagination';
import * as QuickSearch from '@engine/features/quick_search';
import * as RefundEmail from '@engine/features/show_hide_refund_email';
import * as Security from '@engine/features/anti_clickjack';
import * as SelectAll from '@engine/features/select_all';
import * as SelectAllLabel from '@engine/features/select_all_for_labels';
import * as Selectize from '@engine/features/apply_selectize';
import * as ToggleBooleans from '@engine/features/toggle_booleans';
import AnalysisCustomChart from '@engine/features/analysis_stats/custom_chart/component';
import AnalysisStatsChart from '@engine/features/analysis_stats/chart/component';
import BillingSelectDownload from '@engine/features/billing/select_for_download';
import ConfigurableUrl from '@engine/features/configurable_urls';
import Contract from '@engine/features/contract';
import DashboardBars from '@engine/features/dashboard/chart/component';
import DashboardTop5 from '@engine/features/dashboard/top_5/component';
import DependentDropdowns from '@engine/features/dependent_dropdowns';
import Exports from '@engine/features/exports';
import HighlightText from '@engine/features/highlight_words_in_text';
import LoadTerminalRiskFilters from '@engine/features/risk_filter/load_terminal_risk_filters';
import Merchant from '@engine/features/merchant';
import Modal from '@engine/features/modal_dialog';
import NotificationUrl from '@engine/features/notification_urls';
import PaymentTransaction from '@engine/features/payment_transaction';
import Terminal from '@engine/features/terminal';
import VirtualTerminal from '@engine/features/virtual_terminal'; // eslint-disable-next-line sort-imports

import EngineReact from '@engine/engine_react.js';
/**
 * Expose jQuery globally under the window object for RSpec & Development Only
 * Note: Webpack 4 has only Production & Development environments
 */
// eslint-disable-next-line no-process-env

if (process.env.NODE_ENV === 'development') {
  global.$ = global.jQuery = $; // eslint-disable-next-line global-require

  require('fetch-active-counter'); // eslint-disable-next-line global-require


  require('@engine/features/xhr_active_counter');
}

function initializeCommon() {
  // Set Locale
  Locale.setDefaultLocale(); // Enable Sidebar Menu

  Menu.enableMenu();
  Menu.listenForResponsiveMenu(); // Toggle_Booleans (switch icons). Must rename later

  ToggleBooleans.jqueryCssInit();
  /* Dashboard Ratios Show/Hide Buttons */

  DashboardRatios.toggleRatios(); // Bootstrap

  Bootstrap.initDropdownMenuForm();
  Bootstrap.listenForToggleTriggerClick();
  Bootstrap.applyFadeOutToFlashMessages();
  /* Plugin jQuery Chosen */

  Chosen.applyToSelectBoxes();
  Chosen.applyToSelectBoxesWithContentSearch(); // Contracts

  AssignedEntity.handleAssignedEntities();
  Selectize.applySelectize();
  /* Blacklist */

  Blacklists.updateOperatorsOnChange();
  Blacklists.listenForPaymentTransactionClick();
  SelectAll.handleSelectAll(); // Select all by Label for Supported Features, Transaction Types & etc.
  // TODO: "listenForCheckboxesLabelClick" must be refactored.
  // A lot of hardcoded values there.

  SelectAllLabel.listenForTrxCategoryLabelStateChange();
  SelectAllLabel.listenForCheckboxesLabelClick();
  SelectAllLabel.listenForCheckboxesCountryStateChange(); // Billing download select logic

  BillingSelectDownload.handleChecked();
  RefundEmail.listenForSupportRefundEmailOnMidChange(); // Merchant

  Merchant.Wpf.listenForWpfEditableFields();
  Merchant.ReturnUrls.listenForUpdates();
  Merchant.SupportedFeatures.setupGroupCheckboxes();
  Merchant.SupportedFeatures.listenForUpdates();
  Merchant.WpfSupportedFeatures.listenForUpdates();
  Merchant.WpfPaymentLifetime.listenForUpdates();
  Merchant.WpfLocaleText.listenForEdit();
  Merchant.WpfLocaleText.listenForBoundEvents(); // Terminals

  Terminal.RiskFilters.listenForDelete();
  Terminal.RiskFilters.listenForBulkDelete();
  Terminal.RiskFilters.listenForSort();
  Terminal.RiskFilters.listenForBtnToolbarClick();
  Terminal.DependentCheckboxes.listenForTransactionTypesChange();
  Terminal.DependentCheckboxes.listenForSupportedFeaturesChange();
  Terminal.DependentCheckboxes.listenForTrafficShaperClassChange();
  Terminal.DependentCheckboxes.listenForPaymentTypesChange();
  Terminal.listenForModeChange();
  Terminal.listenForMotoCheckboxCheck(); // Risk filters

  LoadTerminalRiskFilters.listenForSourceTerminalChange(); // Contracts aka. MIDs

  Contract.listenForSelecting3dTransaction();
  Contract.listenForGatewayChange();
  Contract.listenForMccChange();
  Contract.listenForMerchantIdChange();
  Contract.listenForMpiChange();
  Contract.listenForMpiModeChange(); // Payment Transactions

  PaymentTransaction.EnforceFilters.enforceDateRangeForFilters();
  PaymentTransaction.AdvancedSearch.init3DSFilters(); // Virtual Terminals

  VirtualTerminal.Change.listenForCountryChange();
  VirtualTerminal.Change.listenForCardNumberChange();
  VirtualTerminal.Change.listenForPaymentTypeChange();
  VirtualTerminal.PayByLink.listenForSendByOptionChange();
  VirtualTerminal.PayByLink.listenForLifetimeSwitchChange();
  VirtualTerminal.PayByLinkConsumers.attachEmailSwitchListener();
  VirtualTerminal.PayByLinkPaymentTypes.listenForChange();
  VirtualTerminal.PayByLinkBankCodes.listenForChange();
  VirtualTerminal.PayByLinkRecurringTypes.listenForChange();
  VirtualTerminal.RemainingAmount.loadRemainingAmount();
  VirtualTerminal.ShippingAddress.handleShippingAddress();
  VirtualTerminal.SupportedCountries.listenForPaymentTypeChange();
  VirtualTerminal.Webmoney.listenForPaymentTypeChange();
  VirtualTerminal.CitadelPayout.listenForCountryChange();
  VirtualTerminal.Entercash.listenForCountryChange();
  VirtualTerminal.Inpay.listenForInpayPaymentTypeChange();
  VirtualTerminal.Inpay.listenForBankSelection();
  VirtualTerminal.Ppro.listenForPaymentMethodChange();
  VirtualTerminal.Invoice.listenForNewItem();
  VirtualTerminal.Invoice.listenForDeleteItem();
  VirtualTerminal.Invoice.listenForInvoiceRefund();
  VirtualTerminal.Invoice.listenForDependentFields();
  VirtualTerminal.MoneyTransfer.listenForTypeChange();
  VirtualTerminal.CountriesWithDocumentId.listenForCountryChange();
  VirtualTerminal.TransferTo.listenForMoneyTransferTypeChange();
  VirtualTerminal.TransferTo.listenForPayerChange();
  VirtualTerminal.BaseMobileInitRecurring.listenForPaymentSubtypeChange();
  VirtualTerminal.NonReferencedRecurring.attachDatePickers(); // Travel

  VirtualTerminal.Travel.listenForAdd();
  VirtualTerminal.Travel.listenForChange();
  VirtualTerminal.Travel.listenForRemoveEntryClick(); // Dynamic filters search

  Filters.listenForSearchFilterSelect();
  Filters.listenForTransactionTypeSelect();
  Filters.listenForSearchFilterRemove();
  Filters.showPopulatedFilters(); // Quick Search

  QuickSearch.enableSearchComponents();
  QuickSearch.listenForResetButton(); // Search Datepicker

  DatePicker.attachDatePicker(); // Load Charts

  AnalysisCustomChart.initialize();
  AnalysisStatsChart.initialize();
  DashboardTop5.initialize();
  DashboardBars.initialize(); // Analysis

  AnalysisStats.listenForAnalysisStatsReset();
  AnalysisStats.loadAnalysisData();
  AnalysisStats.loadChart(); // Charts DateRange Picker

  DateRange.applyDaterangePicker(); // Dashboard

  DashboardPanels.listenForDashboardCurrencyChange();
  DashboardPanels.handleOverviewPanels();
  DashboardPanels.listenForPaginationClick(); // Terminals, MIDs - Pagination

  Pagination.listenForAjaxPaginationClick(); // Managed Recurring Item

  ManagedRecurringItem.attachDatePickers();
  ManagedRecurringItem.listenForIntervalChange();
  ManagedRecurringItem.listenForAddManagedRecurringChange();
  Modals.confirmationModal(); // Exports

  Exports.listenForExports();
  Exports.listenForFileSelect();
  Exports.listenForPrintButtonClick(); // Acquirer

  DependentDropdowns.attachDependentDropdowns(); // ConfigurableUrls

  NotificationUrl.listenForUpdates();
  ConfigurableUrl.listenForEdit(); // Initialize Modal dialog

  Modal.initialize(); // Initialize Highlight logic

  HighlightText.init();
}

function initialize(initializeApp) {
  /**
   * Protection against “Clickjacking”
   * (which is a subset of “UI redressing”)
   */
  Security.preventClickjack();
  /**
   * A jQuery document ready
   */

  $(function () {
    /**
     * Engine Features
     */
    initializeCommon();
    /**
     * Application Features
     */

    if (typeof initializeApp === 'function') {
      initializeApp();
    }
  });
}

var Engine = {
  Legacy: {
    initialize: initialize
  },
  React: {
    initialize: EngineReact.initialize
  }
};
export default Engine;